import { CSSProperties } from 'react';
import { Sequence, staticFile } from 'remotion';

// Components
import { employeeYearInReviewTheme } from '@/components/EmployeeYearInReview/theme';
import { FallbackRemotionImg } from '@/components/common/FallbackRemotionImg';

// Utils
import { combineClasses } from '@/utils/className';
import { processImageUrlForRemotion } from '@/utils/url';

interface PolaroidProps {
  left: number;
  top: number;
  width: number;
  height: number;
  rotation: number;
  name?: string;
  imgSrc?: string;
  className?: string;
  style?: CSSProperties;
}

export const Polaroid = ({
  left,
  top,
  width,
  height,
  rotation,
  imgSrc,
  className,
  style,
  name = 'Polaroid',
}: PolaroidProps) => {
  const processedImgSrc = processImageUrlForRemotion(imgSrc, staticFile);

  return (
    <Sequence
      name={name}
      className={combineClasses(
        'bg-white border origin-center polaroid-frame z-10',
        employeeYearInReviewTheme.colors.borderNeutral,
        className,
      )}
      style={{
        left,
        top,
        width,
        height,
        transform: `rotate(${rotation}deg)`,
        ...style,
      }}
    >
      {processedImgSrc && (
        <div
          className={combineClasses(
            'size-full overflow-hidden',
            employeeYearInReviewTheme.colors.bgNeutralLight,
          )}
        >
          <FallbackRemotionImg
            src={processedImgSrc}
            className="size-full object-cover"
          />
        </div>
      )}
    </Sequence>
  );
};
